// extracted by mini-css-extract-plugin
module.exports = {"lia-kudos-count":"UserKudos_lia-kudos-count__o7EQI"};